<script setup lang="ts">
import type { PropType } from 'vue';
import type { ICON_NAMES } from '~/types';

const props = defineProps<{
  icon: keyof typeof ICON_NAMES;
  mode?: PropType<'svg' | 'css'>;
  size?: string | number;
}>();

const name = `custom:${props.icon}`;
</script>

<template>
  <Icon
    class="block aspect-square w-5 h-auto"
    :name
    :size
  />
</template>

<style lang="scss">
</style>
